var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosedGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70711 4.29289C3.31658 3.90237 2.68342 3.90237 2.29289 4.29289C1.90237 4.68342 1.90237 5.31658 2.29289 5.70711L3.97723 7.39144C3.4406 7.9837 2.99613 8.55525 2.66543 9.01162C2.23392 9.60712 2.23392 10.3929 2.66543 10.9884C3.89979 12.6918 6.71928 16 10 16C10.7401 16 11.4568 15.8316 12.1371 15.5513L14.2929 17.7071C14.6834 18.0976 15.3166 18.0976 15.7071 17.7071C16.0976 17.3166 16.0976 16.6834 15.7071 16.2929L3.70711 4.29289ZM17.3346 10.9884C16.7798 11.754 15.9048 12.8438 14.8117 13.8117L11.8233 10.8233C11.9368 10.5722 12 10.2935 12 10C12 8.89543 11.1046 8 10 8C9.70654 8 9.42783 8.06321 9.17675 8.17675L6.30723 5.30723C7.41197 4.54535 8.66797 4 10 4C13.2807 4 16.1002 7.30816 17.3346 9.01162C17.7661 9.60712 17.7661 10.3929 17.3346 10.9884Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedGray);
export default __webpack_public_path__ + "static/media/eye-closed-gray.fed98cf1b150f76a8892b8edbabdc0a8.svg";
export { ForwardRef as ReactComponent };